export default __webpack_public_path__ + "static/media/warehouse3.3cc56b9a.png";